module.exports = __webpack_public_path__ + "static/fonts/iconfont.7d9e334e.ttf";